export default "__VITE_ASSET__DBEiulTl__"